import { Col, Row } from 'antd'
import { Card, Modal, LoadingSpinner, ButtonGroup, Button, Tooltip, Icon } from 'pepsico-ds'
import React, { useEffect, useState, useRef } from 'react'
import ModalFilters from './ModalFilters';
import ProgressBarChart from '../Charts/ProgressBarChart/ProgressBarChart';
import Legend from '../Charts/Legend/Legend';
import { formatNumberWithCommas } from '../../utils/utils';
import ContractCountSpendChart from "../Charts/ContractChart/ContractCountSpendChart"
import { contractsChartData } from '../../mocks/contractsChartData'
import { splitNumericValue, returnHyphenIfNull, splitValueWithUnit, getBNMNOrKValue, handleDomToImgDownloadPdf } from "../../utils/utils"
import { useDispatch, useSelector } from "react-redux";
import NoData from '../NoData/NoData'
import { localStoreKeys } from '../../constants/localStoreKeys';
import InfoIcon from '../Icons/InfoIcon';
import CommonTable from '../Table/CommonTable'
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';


// const totalActiveContracts = contractsChartData.headerKPIDto.totalActiveContracts==null?0:contractsChartData.headerKPIDto.totalActiveContracts;
// const totalBaseLineSpend = contractsChartData.headerKPIDto.totalBaseLineSpend==null?0:splitNumericValue(contractsChartData.headerKPIDto.totalBaseLineSpend);
// const contractsPaymentsTerms = contractsChartData.headerKPIDto.contractsPaymentsTerms==null?0:contractsChartData.headerKPIDto.contractsPaymentsTerms;
// const contractsWithRebates = contractsChartData.headerKPIDto.contractsWithRebates==null?0:contractsChartData.headerKPIDto.contractsWithRebates;
// const contractsWithTerms = contractsChartData.headerKPIDto.contractsWithTerms==null?0:contractsChartData.headerKPIDto.contractsWithTerms;

// const activeContractChartData = contractsChartData.activeContractsDto.contractsAndSpendDtoList;
// const contractPaymentChartData = contractsChartData.contractsKPIContractsPaymentTermsDto.contractsAndSpendDtoList;

// const rebateContractsSpend = contractsChartData.rebateContractsDto;
// const rebateSpendNumber = rebateContractsSpend.totalValue==null?0:splitNumericValue(rebateContractsSpend.totalValue);

// const contractsWithTermSpend = contractsChartData.contractsWithTermsDto;
// const termSpendNumber = contractsWithTermSpend.totalValue==null?0:splitNumericValue(contractsWithTermSpend.totalValue);

// const contractsWithoutGISR = contractsChartData.contractsWithoutGISRDto;
// const gisrSpendNumber = contractsWithoutGISR.totalValue==null?0:splitNumericValue(contractsWithoutGISR.totalValue);


// const activeContractChartData = [
//     {
//         name: "Exp. 30 days",
//         "Contract Spend": "5",
//         "Number of Contracts": 10,
//     },
//     {
//         name: "Exp. 31-60 days",
//         "Contract Spend": "16",
//         "Number of Contracts": 15,
//     },
//     {
//         name: "Exp. 61-90 days",
//         "Contract Spend": "10",
//         "Number of Contracts": 5,
//     },
//     {
//         name: "Exp. last 90 days",
//         "Contract Spend": "15",
//         "Number of Contracts": 3,
//     },
// ];

// const contractPaymentChartData = [
//     {
//         name: "Payment Terms < 60 days",
//         "Contract Spend": 188,
//         "Number of Contracts": 600,
//     },
//     {
//         name: "Payment Terms 60-90 days",
//         "Contract Spend": 62.7,
//         "Number of Contracts": 200,
//     },
// ];

// import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import CustomButtons from '../Cards/CustomButtons';
import DropdownWithIcons from './DropdownWithIcons';
import LegendList from '../Charts/Legend/LegendList';



const cellDataFunction = (ctx) => {
    const colId = ctx.column.id
    if(ctx.row.original[colId]==null) {
        return <div>-</div>
    }
    // const value = colId==="supplierCount"? formatNumberWithCommas(ctx.row.original[colId]):ctx.row.original[colId] 
    if(colId==='spend') {
        const value = ctx.row.original[colId];
        return <div>{getBNMNOrKValue(value)}</div>
    }
    return <div>{ctx.row.original[colId]}</div>; // <div>{value}</div>;//
}

const contractColumns = [
    { columnKey: 'a', header: '' },
    { columnKey: 'contractNumber', header: "Contract Number", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'sector', header: "Sector", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'l0Category', header: "Category L0", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'l1Category', header: "Category L1", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'l2Category', header: "Category L2", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'companyName', header: "Supplier Name", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'paymentTerms', header: "Discount Term", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'totalSpend', header: "Spend", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
   
]

const contractColumnsToInclude = ["CONTRACT NUMBER","SECTOR", "CATEGORY L0", "CATEGORY L1", "CATEGORY L2", "SUPPLIER NAME", "DISCOUNT TERM", "SPEND"]

const contractColumnMapping = {
    "contractNumber": "CONTRACT NUMBER",
    "sector": "SECTOR",
    "l0Category": "CATEGORY L0",
    "l1Category": "CATEGORY L1",
    "l2Category": "CATEGORY L2",
    "companyName": "SUPPLIER NAME",
    "paymentTerms": "DISCOUNT TERM",
    "totalSpend": "SPEND",
}


const expiringContractColumns = [
    { columnKey: 'a', header: '' },
    { columnKey: 'contractNumber', header: "Contract Number", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'expirationDate', header: "Contract Expiry Date", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'vendorName', header: "Vendor Name", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'sector', header: "Sector", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'bu', header: "Business Unit / Market", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'country', header: "Country", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
    { columnKey: 'spend', header: "Spend Value of Contract", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
   
]
const expiringContractColumnsToInclude = ["CONTRACT NUMBER","CONTRACT EXPIRY DATE", "VENDOR NAME", "SECTOR", "BUSINESS UNIT / MARKET", "COUNTRY", "SPEND VALUE OF CONTRACT"]

const expiringContractColumnMapping = {
    "contractNumber": "CONTRACT NUMBER",
    "expirationDate": "CONTRACT EXPIRY DATE",
    "vendorName": "VENDOR NAME",
    "sector": "SECTOR",
    "bu": "BUSINESS UNIT / MARKET",
    "country": "COUNTRY",
    "spend": "SPEND VALUE OF CONTRACT"
}


function ContractModal({ openModal, setOpenModal, userData, selectedYear, capability, userDataLandingPage, landingPageFilters }) {
    // Track modal view when opened

    useEffect(() => {
        if (openModal) {
            try {
                trackModalView(`${capability}`, 'view');
            } catch (error) {
                // Silent fail for tracking errors to not disrupt user experience
            }
        }
    }, [openModal, capability]);

    const handleClose = () => {
        try {
            trackModalView(`${capability}`, 'close');
        } catch (error) {
            // Silent fail for tracking errors
        }
        setDataLoadActionType("");
        setOpenModal(false);
    };
    const [contractData, setContractData] = useState(null)
    const [loader, setLoader] = useState(false)
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const dispatch = useDispatch();
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const isLoading = useSelector((state) => state?.loader?.isLoading);
    const [dataLoadActionType, setDataLoadActionType] = useState("");
    const [flag, setFlag]= useState(false)
    
    const contractRef = useRef()
    const activeExpiredContractsRef = useRef()
    const activeContractChartRef = useRef()

    const handlePopup = () => {
        setFlag(!flag)
    }
    
    
    const getContractDataFromFilters = (value) => {
        // console.log("contract Data", value);
        setContractData(value.data)
        setLoader(value.loader);
        setDataLoadActionType(value?.data?.type)

        const appList = value.data?.apps
        // const tempbuttonGroupItems = [
        //     {
        //         label:"AMESA Contract Analytics",
        //         onClick: () => window.open("https://app.powerbi.com/groups/6b5771f2-bd7f-47fa-946c-572a2a984fb6/reports/85c7df45-04e9-4f70-a816-a5d6c80aaea5/ReportSectione0fc4b1867bbdaa9b5a4?ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3&experience=power-bi", "_blank"),
        //     }
        // ]
        if (value.modalName == "Contract" && appList && appList.length > 0) {
            const tempbuttonGroupItems = appList
                ?.filter(item => item.isActive)
                .map(item => ({
                    label: item.app,
                    onClick: () => window.open(item.url, "_blank"),
                }));
            
            setButtonGroupItems(tempbuttonGroupItems)
        } else {
            setButtonGroupItems([])
        }
    }

    const totalActiveContracts = contractData?.headerKPIDto?.totalActiveContracts == null ? 0 : contractData?.headerKPIDto?.totalActiveContracts;
    const totalExpiredContracts = contractData?.headerKPIDto?.totalExpiredContracts == null ? 0 : contractData?.headerKPIDto?.totalExpiredContracts;
    const totalBaseLineSpend = contractData?.headerKPIDto?.totalBaseLineSpend == null ? 0 : splitNumericValue(contractData?.headerKPIDto?.totalBaseLineSpend);
    const contractsPaymentsTerms = contractData?.headerKPIDto?.contractsPaymentsTerms == null ? 0 : contractData?.headerKPIDto?.contractsPaymentsTerms;
    const contractsWithRebates = contractData?.headerKPIDto?.contractsWithRebates == null ? 0 : contractData?.headerKPIDto?.contractsWithRebates;
    const contractsWithTerms = contractData?.headerKPIDto?.contractsWithTerms == null ? 0 : contractData?.headerKPIDto?.contractsWithTerms;

    const activeContractChartData = contractData?.activeContractsDto?.contractsAndSpendDtoList;
    const contractPaymentChartData = contractData?.contractsKPIContractsPaymentTermsDto?.contractsAndSpendDtoList;

    const rebateContractsSpend = contractData?.rebateContractsDto;
    const rebateSpendNumber = rebateContractsSpend?.totalValue == null ? 0 : splitNumericValue(rebateContractsSpend?.totalValue);

    const contractsWithTermSpend = contractData?.contractsWithTermsDto;
    const termSpendNumber = contractsWithTermSpend?.totalValue == null ? 0 : splitNumericValue(contractsWithTermSpend?.totalValue);

    const contractsWithoutGISR = contractData?.contractsWithoutGISRDto;
    const gisrSpendNumber = contractsWithoutGISR?.totalValue == null ? 0 : splitNumericValue(contractsWithoutGISR?.totalValue);

    const discountedContracts = contractData?.discountedContractsDto;
    const discountedContractsSpendNumber = discountedContracts?.totalValue == null ? 0 : splitNumericValue(discountedContracts?.totalValue);
    const savingsOpportunity = discountedContracts?.totalDiscountSavings == null ? 0 : splitNumericValue(discountedContracts?.totalDiscountSavings);
    const discountedTermTableData = contractData?.discountedContractsInfo;
    const expiringContractsTableData = contractData?.expiringContractsDetails;

    const appOwnersList = contractData?.owners
    const emailList = appOwnersList?.map(contact => contact.emailId).join(', ');

    const isEDFIntegrated = contractData?.edfintegrated;

    const { showToast } = useToast();


    
    const checkPDFDownloaded = () => {}
    


    return (
        <Modal
            onCloseModal={handleClose}
            primaryButtonProps={{
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showAuxiliaryButton={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showSlot={true}
            showModal={openModal}
            closeOnOutsideClick={false}
            hideCloseButton={false}
            type="XL"
            {...getModalAttributes(capability)}
        >
            <div ref={contractRef}>
                <div className="modal-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>{userData?.FirstName}, total active contracts for your category are <b>{formatNumberWithCommas(totalActiveContracts)}</b>
                        <sup><InfoIcon text="Active Contracts include 'Active' and 'In-Progress'" /></sup>
                        {
                            isEDFIntegrated &&
                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                            </Tooltip>
                        }
                    </span>
                    {
                        loader ? (
                            <></>
                        ) :                    
                        <>
                            {/* <ButtonGroup
                                style={{ marginRight: '2rem' }}
                                className="buy-con-button-group"
                                items={buttonGroupItems}
                                size="small"
                            /> */}
                            <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <CustomButtons isModal={true} appList={contractData?.apps} />
                                {/* <button onClick={() => handleDomToImgDownloadPdf(contractRef, "Contract_Modal")}>PDF</button> */}
                                <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}>
                                    <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={contractRef} kpiName={"Contract_Modal"} isModal={true}/>
                                </span>
                            </span>
                        </>
                    }
                </div>
                <div className="modal-update-frequesncy" style={{ marginBottom: "5px", display: "flex" }}><Icon alt="" icon="info" size="small" /> &nbsp; {staticNotes.CONTRACT_EDF_NOTE}</div>
            
                <div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(contractData?.lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(contractData?.refreshFrequency)}</div>
                {/* <ModalFiltersTemp selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getContractDataFromFilters} landingPageFilters={landingPageFilters} setLoader={setLoader} /> */}
                <ModalFilters modalName={"Contract"} selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getContractDataFromFilters} landingPageFilters={landingPageFilters} setLoader={setLoader} />
                <br />

                { 
                        flag && <div>
                                

                                <Modal
                                onCloseModal={handlePopup}
                                primaryButtonProps={{
                                    onClick: handlePopup,
                                    size: "small",
                                    text: "Close",
                                    variant: "primary",
                                }}
                                showPrimaryButton={false}
                                showLink={false}
                                showAuxiliaryButton={false}
                                showSecondaryButton={false}
                                showTertiaryButton={false}
                                showSlot={true}
                                showModal={openModal}
                                closeOnOutsideClick={false}
                                hideCloseButton={false}
                                type="M"
                                >
                                {
                                    discountedTermTableData?.length > 0 ?
                                    <div className="ph-table-wrapper">
                                    <CommonTable className={"contracts-table"} 
                                        columns={contractColumns} data={discountedTermTableData} 
                                        tableHeader={"'Discounted' Contract Details"} 
                                        enableSorting={true} columnsToInclude={contractColumnsToInclude} 
                                        columnMapping={contractColumnMapping} 
                                        tableName={'CONTRACT DETAILS'}/>
                                    </div>    
                                        :
                                        <NoData />
                                }
                                </Modal>
                    </div>
                }

                {
                    (dataLoadActionType!=="SUCCESS_CONTRACT_DETAIL_VIEW_ACTION" || loader || isLoading) ? // 
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                        </div>
                        :
                        <>
                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Card style={{ height: '100%',display:'flex' }}>
                                <div className='header-kpi-wrapper'>
                                {
                                    totalActiveContracts ?
                                        <>
                                            <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                                <div className="spend-modal-alphanumeric-value">
                                                    <div className='spend-modal-numeric-value' style={{ display: "flex" }}>
                                                        {formatNumberWithCommas(totalActiveContracts)}
                                                        <sup style={{ marginTop: "-5px" }}><InfoIcon text="Active Contracts include 'Active' and 'In-Progress'" direction='right' /></sup>
                                                    </div>
                                                </div>
                                                <div className='spend-modal-total-spend-text'>Total Active Contracts</div>
                                            </Col>
                                        </> : ''
                                }

                                {
                                    totalExpiredContracts ?
                                        <>
                                            <div className="modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                                <div className="spend-modal-alphanumeric-value">
                                                    <div className='spend-modal-numeric-value'>{formatNumberWithCommas(totalExpiredContracts)}</div>
                                                </div>
                                                <div className='spend-modal-total-spend-text'>Total Expired Contracts</div>
                                            </Col>
                                        </> : ''
                                }

                                {
                                    totalBaseLineSpend?.value != null ?
                                        <>
                                            <div className="modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={4} lg={4} xl={4}>

                                                <div>
                                                    <div className="spend-modal-alphanumeric-value-small">
                                                        <div className='spend-modal-numeric-value-small'>{totalBaseLineSpend.value}</div>
                                                        <div className="spend-modal-alpha-value-small">{totalBaseLineSpend.suffix}</div>
                                                    </div>
                                                    <div className='spend-modal-manage-spend'>Total baseline spend for Active Contracts</div>
                                                </div>
                                            </Col>
                                        </> : ''
                                }

                                {/* {
                                    contractsPaymentsTerms ?
                                        <>
                                            <div className="modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={4} lg={4} xl={4}>

                                                <div>
                                                    <div className="spend-modal-total-supplier">{contractsPaymentsTerms}</div>
                                                    <div className='spend-modal-manage-spend'>Contracts Payment Terms</div>
                                                </div>
                                            </Col>
                                        </> : ''
                                } */}

                                {
                                    contractsWithRebates ?
                                        <>
                                            <div className="modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={4} lg={4} xl={4}>

                                                <div>
                                                    <div className="spend-modal-total-supplier">{contractsWithRebates}</div>
                                                    <div className='spend-modal-manage-spend'>Contracts with Rebates</div>
                                                </div>
                                            </Col>
                                        </> : ''
                                }

                                {
                                    contractsWithTerms ?
                                        <>
                                            <div className="modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={4} lg={4} xl={4}>

                                                <div>
                                                    <div className="spend-modal-total-supplier">{contractsWithTerms}</div>
                                                    <div className='spend-modal-manage-spend'>{"Contracts with Term > 2 Years"}</div>
                                                </div>
                                            </Col>
                                        </> : ''
                                }
                                </div>
                            </Card>
                            </Col> 
                            </Row>
                            <br />
                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                   
                                        <Card>
                                            <Row style={{ width: "100%" }} justify={"space-between"}>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    {
                                                        contractPaymentChartData?.length > 0 || activeContractChartData?.length > 0 ?
                                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "14px" }}>
                                                                {/* <Legend title1="Number of Contracts" title2="Contract Spend" /> */}
                                                                <LegendList legends={[
                                                                    { name: 'Number of Contracts', color: '#0078A7'},
                                                                    { name: 'Contract Spend', color:"#B05788"},
                                                                ]}/>
                                                            </div> :
                                                            ''
                                                    }
                                                </Col>
                                                <Col xs={24} sm={24} md={12} lg={11} xl={11}>
                                                <div ref={activeExpiredContractsRef}>
                                                        {
                                                            activeContractChartData?.length > 0 ?
                                                                <>
                                                                    <div className='contract-chart-title'>Active/Expired Contracts
                                                                        <span style={{float: 'right'}}>
                                                                            <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={activeExpiredContractsRef} kpiName={"Active/Expired Contracts"} />
                                                                        </span>
                                                                    </div>
                                                                    <ContractCountSpendChart data={activeContractChartData} xAxisLabel="Contracts Spend in $ (MN)"
                                                                        xPrimaryDataKey="noOfContracts" xSecodaryDataKey="totalSpend" yDataKey="name" tooltipMessage={""} />
                                                                </> :
                                                                <NoData />
                                                        }
                                                        <br/>
                                                    </div>
                                                </Col>
                                                <Col xs={24} sm={24} md={12} lg={11} xl={11}>
                                                    <div ref={activeContractChartRef}>
                                                        {
                                                            contractPaymentChartData?.length > 0 ?
                                                                <>
                                                                    <div className='contract-chart-title'>
                                                                        Contracts Payment Terms
                                                                        <span style={{float: 'right'}}>
                                                                            <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={activeContractChartRef} kpiName={"Contracts Payment Terms"} />
                                                                        </span>
                                                                    </div>
                                                                    <ContractCountSpendChart data={contractPaymentChartData} xAxisLabel="Contracts Spend in $ (MN)"
                                                                        xPrimaryDataKey="noOfContracts" xSecodaryDataKey="totalSpend" yDataKey="name" tooltipMessage={"Contracts without Payment Term won't be displayed here"} />
                                                                </> :
                                                                <NoData />
                                                        }
                                                        <br/>
                                                    </div>
                                                </Col>

                                            </Row>
                                        </Card>
                                    
                                </Col>
                            </Row>
                            <br />
                            <Row gutter={[10, 10]} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Card style={{ height: "100%" }}>
                                        <div className='contract-progressbar-container'>
                                            {
                                                rebateSpendNumber?.value != null ?
                                                    <>
                                                        <div className='contract-progress-title'>Rebate Contracts
                                                        </div>
                                                        <div className='contract-progress-value'>
                                                            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                <div className='contract-progress-value-value'>{rebateSpendNumber.value}</div>
                                                                <div className='contract-progress-value-alpha'>{rebateSpendNumber.suffix}</div>
                                                            </div>
                                                            <div className='contract-progress-value-right'>Total Contracts <b>{rebateContractsSpend?.totalContracts}</b></div>
                                                        </div>
                                                        <ProgressBarChart progress={rebateContractsSpend?.percentage} label="" />
                                                        <div className='contract-progress-footer'>
                                                            {rebateContractsSpend?.percentage}% <span style={{ fontWeight: 400 }}>share of</span> Total Contracts Spend
                                                        </div>
                                                    </> :
                                                    <NoData />
                                            }
                                        </div>
                                    </Card>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Card style={{ height: "100%" }}>
                                        <div className='contract-progressbar-container'>
                                            {
                                                termSpendNumber?.value != null ?
                                                    <>
                                                        <div className='contract-progress-title'>{`Contracts with Term > 2 Years`}</div>
                                                        <div className='contract-progress-value'>
                                                            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                <div className='contract-progress-value-value'>{termSpendNumber.value}</div>
                                                                <div className='contract-progress-value-alpha'>{termSpendNumber.suffix}</div>
                                                            </div>
                                                            <div className='contract-progress-value-right'>Total Contracts <b>{contractsWithTermSpend?.totalContracts}</b></div>
                                                        </div>
                                                        <ProgressBarChart progress={contractsWithTermSpend?.percentage} label="" />
                                                        <div className='contract-progress-footer'>
                                                            {contractsWithTermSpend?.percentage}% <span style={{ fontWeight: 400 }}>share of</span> Total Contracts Spend
                                                        </div>
                                                    </> :
                                                    <NoData />
                                            }
                                        </div>
                                    </Card>
                                </Col>
                            </Row>
                            <br />   
                            <Row gutter={[10, 10]} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Card style={{ height: "100%" }}>
                                        <div className='contract-progressbar-container'>
                                            {
                                                gisrSpendNumber?.value != null ?
                                                    <>
                                                        <div className='contract-progress-title'>Contracts without GISR Clause</div>
                                                        <div className='contract-progress-value'>
                                                            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                <div className='contract-progress-value-value'>{gisrSpendNumber.value}</div>
                                                                <div className='contract-progress-value-alpha'>{gisrSpendNumber.suffix}</div>
                                                            </div>
                                                            <div className='contract-progress-value-right'>Total Contracts <b>{contractsWithoutGISR?.totalContracts}</b></div>
                                                        </div>
                                                        <ProgressBarChart progress={contractsWithoutGISR?.percentage} label="" />
                                                        <div className='contract-progress-footer'>
                                                            {contractsWithoutGISR?.percentage}% <span style={{ fontWeight: 400 }}>share of</span> Total Contracts Spend
                                                        </div>
                                                    </> :
                                                    <NoData />
                                            }
                                        </div>
                                    </Card>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Card style={{ height: "100%" }}>
                                        <div className='contract-progressbar-container'>
                                        {
                                                discountedContractsSpendNumber?.value != null ?
                                                    <>
                                                        <div className='contract-progress-title'>Early Payment Discounted Contracts 
                                                                &nbsp;<span onClick={handlePopup} 
                                                                        onKeyDown={(e) => {
                                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                                            e.preventDefault(); // Prevents page scrolling on spacebar
                                                                            handlePopup();
                                                                        }
                                                                        }}><InfoIcon text="Click to view discount summary" /></span>
                                                        </div>
                                                        <div style={{ display: 'flex', width: '100%' }}>
                                                            
                                                            {/* Left 70% */}
                                                            <div style={{ width: '70%' }}>
                                                                
                                                                <div className='contract-progress-value'>
                                                                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                    <div className='contract-progress-value-value'>{discountedContractsSpendNumber.value}</div>
                                                                    <div className='contract-progress-value-alpha'>{discountedContractsSpendNumber.suffix}</div>
                                                                </div>
                                                                <div className='contract-progress-value-right'>
                                                                    Total Contracts <b>{discountedContracts?.totalContracts}</b>
                                                                </div>
                                                                </div>
                                                                <ProgressBarChart progress={discountedContracts?.percentage} label="" />
                                                            </div>

                                                            {/* Right 30% */}
                                                            <div style={{ width: '30%', display:"flex" }}>
                                                                
                                                                <div className="modal-divider-verticle" />
                                                                {/* Add your additional content here */}
                                                                <div className='additional-info'>
                                                                {/* Example content */}
                                                                    <div>
                                                                        <div className="spend-modal-alphanumeric-value-small">
                                                                            <div className='spend-modal-numeric-value-small' style={{ fontSize:'24px' }}>{savingsOpportunity.value}</div>
                                                                            <div className="spend-modal-alpha-value-small"  style={{ fontSize:'13px' }}>{savingsOpportunity.suffix}</div>
                                                                        </div>
                                                                        <div className='spend-modal-manage-spend' style={{lineHeight:'142%'}}>Potential Discount Savings Opportunity</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className='contract-progress-footer'>
                                                                    {discountedContracts?.percentage}% <span style={{ fontWeight: 400 }}>share of</span> Total Contracts Spend
                                                        </div>
                                                    </> :
                                                    <NoData />
                                            }
                                        </div>
                                    </Card>
                                </Col>
                            </Row>
                            <br />

                            <Row gutter={[10, 10]} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    {
                                        expiringContractsTableData?.length > 0 ?
                                            <div className="ph-table-wrapper">
                                                <CommonTable className={"expiring-contracts-table"} 
                                                    columns={expiringContractColumns} data={expiringContractsTableData} 
                                                    tableHeader={"Contract Details"} 
                                                    enableSorting={true} columnsToInclude={expiringContractColumnsToInclude} 
                                                    columnMapping={expiringContractColumnMapping} 
                                                    tableName={'CONTRACT DETAILS'}/>
                                            </div>    
                                            :  
                                            <Card><NoData/></Card>
                                    }
                                </Col>
                            </Row>
                            <br />


                            <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                {appOwnersList?.length > 0 &&
                                    <div style={{width: '100%'}}>Please reach out to {appOwnersList?.map((contact, index) => (
                                        <React.Fragment key={index}>
                                            <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                            {index < appOwnersList.length - 1 && ', '}
                                        </React.Fragment>
                                    ))} for any query on the data displayed.</div>
                                }
                                <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                            </div>
                        </>
                }
                <br/>
            </div>
        </Modal>
    )
}

export default ContractModal